import React from "react";
import { Collapse, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  collapseRoot: {
    width: "100%",
  },
}));

const SectionTitleCollapse = ({ in: open = false, children, timeout = 450 }) => {
  const classes = useStyles();

  return (
    <Collapse
      in={open}
      timeout={timeout}
      classes={{ root: classes.collapseRoot }}
    >
      {children}
    </Collapse>
  );
};

export default SectionTitleCollapse;
